
import React, { useRef, useEffect, useState } from 'react';       
import { useNavigate } from 'react-router-dom';

import styles from './PigeonsNew.module.css';
import Logo from '../../assets/logo_white.png';
import AvatarImage from '../../assets/PigeonsCatalog/Avatar.png';
import customIcon1 from '../../assets/PigeonsCatalog/pearson_catalog.svg';
import customIcon2 from '../../assets/PigeonsCatalog/wing_catalog.svg';
import customIcon3 from '../../assets/PigeonsCatalog/pair_catalog.svg';
import customIcon4 from '../../assets/PigeonsCatalog/genealogy_catalog.svg';
import customIcon5 from '../../assets/PigeonsCatalog/flight_catalog.svg';
import pigeonImage from '../../assets/main-pigeon.png';

import PigeonList from './PigeonList.jsx';
import { Search, SlidersHorizontal, ArrowUpDown, Grid2x2, List } from 'lucide-react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Card, CardMedia, Grid, AppBar, Toolbar, Typography, IconButton, Avatar, Menu, MenuItem, colors, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, InputLabel, Select, Checkbox, Box} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';


const PigeonsNew = () => {
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [addPigeonOpen, setAddPigeonOpen] = useState(false);
    const [editingPigeon, setEditingPigeon] = useState(null);
    const [selectedPigeons, setSelectedPigeons] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);
    const [sortOpen, setSortOpen] = useState(false);
    const [filters, setFilters] = useState({
        gender: '',
        status: ''
    });
    const [sortBy, setSortBy] = useState('');
    const [viewMode, setViewMode] = useState('grid'); // 'grid' lub 'list'
    const [search, setSearch] = useState('');
    // Funkcja do zapisywania liczby gołębi do localStorage
    const savePigeonsCount = (count) => {
        localStorage.setItem('pigeonsCount', count.toString());
          };

    // Funkcja do wczytywania danych z localStorage
    const loadPigeonsData = () => {
        const saved = localStorage.getItem('pigeonsData');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                // Konwertuj dateAdded z powrotem na Date
                return parsed.map(p => ({
                    ...p,
                    dateAdded: new Date(p.dateAdded)
                }));
            } catch (e) {
                console.error('Błąd wczytywania danych z localStorage:', e);
            }
        }
        return [
        {
          ID: 1,
          name: "Henrick's",
          gender: 'Samiec',
          number: 'PL-0423-12345-6d',
          status: 'Rozpłodowy',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-01-15'),
        },
        {
          ID: 2,
              name: "Adamczyk Team",
          gender: 'Samica',
              number: 'PL-0423-12345-7d',
          status: 'Rozpłodowy',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-01-20'),
        },
        {
          ID: 3,
          name: "Henrick's",
          gender: 'Samiec',
              number: 'PL-0423-12345-8d',
          status: 'Rozpłodowy',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-02-01'),
        },
        {
          ID: 4,
              name: "Breeder's Choice",
          gender: 'Samica',
              number: 'PL-0423-12345-9d',
          status: 'Rozpołodowy',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-02-10'),
        },
        {
          ID: 5,
          name: "Henrick's",
          gender: 'Samica',
              number: 'PL-0423-12345-10d',
          status: 'Lotowy',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-02-15'),
        },
        {
          ID: 6,
              name: "Champion's Pride",
          gender: 'Samica',
              number: 'PL-0423-12345-11d',
          status: 'Lotowy',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-02-20'),
        },
        {
          ID: 7,
          name: "Henrick's",
          gender: 'Samiec',
              number: 'PL-0423-12345-12d',
          status: 'Lotowy',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-03-01'),
        },
        {
          ID: 8,
              name: "Elite Racing",
          gender: 'Samiec',
              number: 'PL-0423-12345-13d',
          status: 'Nieaktywny',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-03-05'),
        },
        {
          ID: 9,
          name: "Henrick's",
          gender: 'Samica',
              number: 'PL-0423-12345-14d',
              status: 'Nieaktywny',
          image: `${pigeonImage}`,
              dateAdded: new Date('2024-03-10'),
        },
      ];
    };

    const [pigeonsData, setPigeonsData] = useState(() => {
        const data = loadPigeonsData();
        // Zapisz początkową liczbę gołębi
        savePigeonsCount(data.length);
        return data;
    });

    const [pigeonForm, setPigeonForm] = useState({
        name: '',
        gender: '',
        number: '',
        status: '',
        image: pigeonImage
    });

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleAddPigeon = () => {
        setEditingPigeon(null);
        setPigeonForm({
            name: '',
            gender: '',
            number: '',
            status: '',
            image: pigeonImage
        });
        setAddPigeonOpen(true);
    };

    const handleEditPigeon = (pigeon) => {
        setEditingPigeon(pigeon);
        setPigeonForm({
            name: pigeon.name,
            gender: pigeon.gender,
            number: pigeon.number,
            status: pigeon.status,
            image: pigeon.image
        });
        setAddPigeonOpen(true);
    };

    const handleCloseAddPigeon = () => {
        setAddPigeonOpen(false);
        setEditingPigeon(null);
    };

    const handleSavePigeon = () => {
        if (editingPigeon) {
            // Edycja istniejącego gołębia
            setPigeonsData(prev => {
                const updated = prev.map(p => 
                    p.ID === editingPigeon.ID 
                        ? { ...p, ...pigeonForm }
                        : p
                );
                // Zapisz do localStorage
                localStorage.setItem('pigeonsData', JSON.stringify(updated));
                savePigeonsCount(updated.length);
                return updated;
            });
        } else {
            // Dodanie nowego gołębia
            const newPigeon = {
                ID: pigeonsData.length > 0 ? Math.max(...pigeonsData.map(p => p.ID)) + 1 : 1,
                ...pigeonForm,
                dateAdded: new Date()
            };
            setPigeonsData(prev => {
                const updated = [...prev, newPigeon];
                // Zapisz do localStorage
                localStorage.setItem('pigeonsData', JSON.stringify(updated));
                savePigeonsCount(updated.length);
                return updated;
            });
        }
        handleCloseAddPigeon();
    };

    const handleDeletePigeons = () => {
        if (selectedPigeons.length > 0) {
            if (window.confirm(`Czy na pewno chcesz usunąć ${selectedPigeons.length} gołębi?`)) {
                setPigeonsData(prev => {
                    const updated = prev.filter(p => !selectedPigeons.includes(p.ID));
                    // Zapisz do localStorage
                    localStorage.setItem('pigeonsData', JSON.stringify(updated));
                    savePigeonsCount(updated.length);
                    return updated;
                });
                setSelectedPigeons([]);
            }
        }
    };

    const handleToggleSelect = (pigeonId) => {
        setSelectedPigeons(prev => 
            prev.includes(pigeonId)
                ? prev.filter(id => id !== pigeonId)
                : [...prev, pigeonId]
        );
    };

    const handlePigeonFormChange = (field, value) => {
        setPigeonForm(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPigeonForm(prev => ({
                    ...prev,
                    image: reader.result
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handlePedigreeClick = (pigeonId) => {
        navigate(`/pedigree?pigeonId=${pigeonId}`);
    };

    const handleFilterOpen = () => {
        setFilterOpen(true);
    };

    const handleFilterClose = () => {
        setFilterOpen(false);
    };

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleApplyFilters = () => {
        setFilterOpen(false);
    };

    const handleClearFilters = () => {
        setFilters({
            gender: '',
            status: ''
        });
    };

    const handleSortOpen = () => {
        setSortOpen(true);
    };

    const handleSortClose = () => {
        setSortOpen(false);
    };

    const handleSortChange = (value) => {
        setSortBy(value);
        setSortOpen(false);
    };

    const handleClearSort = () => {
        setSortBy('');
    };

    // Funkcja filtrowania i sortowania
    const getFilteredAndSortedPigeons = () => {
        let filtered = [...pigeonsData];

        // Filtrowanie
        if (search.trim()) {
            const term = search.toLowerCase();
            filtered = filtered.filter((p) =>
                (p.name || '').toLowerCase().includes(term) ||
                (p.number || '').includes(search)
            );
        }
        if (filters.gender) {
            filtered = filtered.filter(p => p.gender === filters.gender);
        }
        if (filters.status) {
            filtered = filtered.filter(p => p.status === filters.status);
        }

        // Sortowanie
        if (sortBy === 'name-asc') {
            filtered.sort((a, b) => a.name.localeCompare(b.name));
        } else if (sortBy === 'name-desc') {
            filtered.sort((a, b) => b.name.localeCompare(a.name));
        } else if (sortBy === 'date-asc') {
            filtered.sort((a, b) => a.dateAdded - b.dateAdded);
        } else if (sortBy === 'date-desc') {
            filtered.sort((a, b) => b.dateAdded - a.dateAdded);
        }

        return filtered;
    };

    const filteredAndSortedPigeons = getFilteredAndSortedPigeons();

    const handleClick = (index, name) => {
        return () => {
            switch(index) {
                case 0: // Panel hodowcy
                    navigate('/panel');
                    break;
                case 1: // Gołębie
                    navigate('/pigeons-new');
                    break;
                case 2: // Rodowody
                    navigate('/pedigree');
                    break;
                case 3: // Parowanie
                    navigate('/pairing');
                    break;
                case 4: // Loty
                    navigate('/flights');
                    break;
                default:
                    break;
            }
        };
    }

    const iconLabels = [
        'Panel hodowcy',
        'Gołębie',
        'Rodowody',
        'Parowanie',
        'Loty'
      ];

  const icons = [customIcon1, customIcon2, customIcon4, customIcon3, customIcon5];

    return (
        <div className={styles['content-container']}>
        <Grid container spacing={0} sx={{minHeight: '100vh', margin: 0}}>
          <Grid sx={{minHeight: '100vh', height: '100%', backgroundColor: '#478E94', position: { xs: 'relative', md: 'sticky' }, top: 0, bottom: 0, alignSelf: 'flex-start', margin: 0}} item xs={12} md={2}>
            <Card sx={{
              borderRadius:0,
              backgroundColor:'#478E94',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center', 
              margin: { xs: 1, md: 2 },
              boxShadow: 'none',
            }}>
              <CardMedia
                component="img"
                image={Logo}
                alt="Logo"
                sx={{
                  width: { xs: 120, md: '50%' },
                  maxWidth: '80%',
                  height: 'auto', 
                  background: '#478E94',
                }}
              />
            </Card>
                    <div className={styles['all-icons-container']}>
                            {icons.map((icon, index) => (
                                <div className={styles['icon-container']} key={index} tabindex="0" onClick={handleClick(index, iconLabels[index])}>
                                    <img className={styles['custom-icon']} src={icon} alt={`Custom Icon ${index + 1}`} />
                                    <p className={styles['icon-label']}>{iconLabels[index]}</p>
                                </div>
                            ))}
                    </div>

                </Grid>
            
                <Grid item xs={12} md={10}>
                    <div className={styles['header-container']}>
                        <div className={styles['text-header-container']}>
                            <span className={styles['text-grey-header-catalog']}> Moje gołębie </span>
                        </div>

                        <div className={styles['avatar-container']}>
                            <Avatar className={styles.avatar} alt="Name" src={AvatarImage} />
                            <Menu
                                id="profile-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                            >
                                <MenuItem onClick={handleMenuClose}>Profil</MenuItem>
                                <MenuItem onClick={handleMenuClose}>Ustawienia</MenuItem>
                                <MenuItem onClick={() => {
                                    handleMenuClose();
                                    navigate('/');
                                }}>Wyloguj</MenuItem>
                            </Menu>
                            <Typography sx={{fontSize: '18px', color: '#2A2A2A', fontFamily: "'Poppins', sans-serif", fontWeight: 500}}>Krzysztof</Typography>
                            <IconButton color="inherit" onClick={handleMenuOpen}>
                                <ExpandMoreIcon style={{fontSize: '3.6vh'}}/>
                            </IconButton>
                        </div>

                    </div>

                <div className={styles['catalog-option']} style={{maxWidth: 1820, marginLeft: 'auto', marginRight: 'auto', width: 'calc(100% - 40px)'}}>
                  <div className={styles['left-group-button']}>
                    <button
                        type="button"
                        className={styles['add-button']}
                        onClick={handleAddPigeon}
                        style={{ background: '#2a9d8f', color: '#e1f5ee', border: 'none', padding: '10px 22px', borderRadius: 22, fontSize: 'clamp(13px, 0.9vw, 16px)', fontWeight: 600 }}
                    >
                        + Dodaj gołębia
                    </button>
                    <button 
                        type="button" 
                        className={styles['delete-button']} 
                        onClick={handleDeletePigeons}
                        disabled={selectedPigeons.length === 0}
                        style={{ background: 'white', border: '0.5px solid #ddd', color: '#666', padding: '10px 20px', borderRadius: 22, fontSize: 'clamp(13px, 0.85vw, 15px)', fontWeight: 500 }}
                    >
                        Usuń{selectedPigeons.length > 0 ? ` (${selectedPigeons.length})` : ''}
                    </button>
                  </div>
                  <div className={styles['right-group-button']}>
                    <button type="button" className={styles['filter-button']} onClick={handleFilterOpen} style={{background:'white', border:'0.5px solid #ddd', color:'#666', padding:'10px 18px', borderRadius:22, fontSize:'clamp(13px, 0.85vw, 15px)', fontWeight:500, display:'flex', alignItems:'center', gap:8}}>
                      <SlidersHorizontal size={16} /> 
                      Filtruj
                      {(filters.gender || filters.status) && <span style={{marginLeft: '5px', backgroundColor: '#57C09A', color: 'white', borderRadius: '50%', width: '20px', height: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px'}}>!</span>}
                    </button>
                    <button type="button" className={styles['sort-button']} onClick={handleSortOpen} style={{background:'white', border:'0.5px solid #ddd', color:'#666', padding:'10px 18px', borderRadius:22, fontSize:'clamp(13px, 0.85vw, 15px)', fontWeight:500, display:'flex', alignItems:'center', gap:8}}>
                      <ArrowUpDown size={16} /> 
                      Sortuj
                      {sortBy && <span style={{marginLeft: '5px', backgroundColor: '#57C09A', color: 'white', borderRadius: '50%', width: '20px', height: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px'}}>!</span>}
                    </button>
                    <div style={{display:'flex', background:'white', border:'0.5px solid #eee', borderRadius:12, overflow:'hidden', marginLeft: '8px'}}>
                      <button 
                        type="button" 
                        className={styles['view-toggle-button']}
                        onClick={() => setViewMode('grid')}
                        style={{
                          padding:'9px 14px',
                          background: viewMode === 'grid' ? '#2a9d8f' : 'transparent',
                          color: viewMode === 'grid' ? '#e1f5ee' : '#999',
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <Grid2x2 size={16} />
                      </button>
                      <button 
                        type="button" 
                        className={styles['view-toggle-button']}
                        onClick={() => setViewMode('list')}
                        style={{
                          padding:'9px 14px',
                          background: viewMode === 'list' ? '#2a9d8f' : 'transparent',
                          color: viewMode === 'list' ? '#e1f5ee' : '#999',
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <List size={16} />
                      </button>
                    </div>
                  </div>
                </div>

                <div style={{position:'relative', margin:'0 auto 16px', maxWidth: 1820, width: 'calc(100% - 40px)'}}>
                  <Search size={15} style={{position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'#aaa'}} />
                  <input
                    placeholder="Szukaj po nazwie lub numerze obrączki…"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    style={{width:'100%', padding:'10px 14px 10px 38px', border:'0.5px solid #ddd', borderRadius:10, fontSize:13, boxSizing:'border-box'}}
                  />
                </div>

                <div className={styles['pigeon-list-container']} style={{maxWidth: 1820, margin: '0 auto 24px', width: 'calc(100% - 40px)'}}>
                    <PigeonList 
                        pigeons={filteredAndSortedPigeons} 
                        onEdit={handleEditPigeon}
                        selectedPigeons={selectedPigeons}
                        onToggleSelect={handleToggleSelect}
                        viewMode={viewMode}
                        onPedigree={handlePedigreeClick}
                    />
                </div>
                
            </Grid>

        </Grid>

        {/* Dialog do dodawania/edycji gołębia */}
        <Dialog open={addPigeonOpen} onClose={handleCloseAddPigeon} maxWidth="md" fullWidth>
            <DialogTitle sx={{fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: '28px', color: '#478E95'}}>
                {editingPigeon ? 'Edytuj gołębia' : 'Dodaj gołębia'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 3, marginTop: 2}}>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2}}>
                        <Box
                            component="img"
                            src={pigeonForm.image}
                            alt="Pigeon"
                            sx={{
                                width: 200,
                                height: 200,
                                objectFit: 'cover',
                                borderRadius: 2,
                                border: '2px solid #57C09A'
                            }}
                        />
                        <Button 
                            variant="outlined" 
                            component="label"
                            sx={{
                                fontFamily: "'Poppins', sans-serif",
                                textTransform: 'none',
                                borderColor: '#57C09A',
                                color: '#57C09A',
                                '&:hover': {
                                    borderColor: '#4fcda2',
                                    backgroundColor: 'rgba(87, 192, 154, 0.1)'
                                }
                            }}
                        >
                            Zmień zdjęcie
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                        </Button>
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Nazwa"
                                value={pigeonForm.name}
                                onChange={(e) => handlePigeonFormChange('name', e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        fontFamily: "'Poppins', sans-serif",
                                    },
                                    '& .MuiInputLabel-root': {
                                        fontFamily: "'Poppins', sans-serif",
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel sx={{fontFamily: "'Poppins', sans-serif"}}>Płeć</InputLabel>
                                <Select
                                    value={pigeonForm.gender}
                                    label="Płeć"
                                    onChange={(e) => handlePigeonFormChange('gender', e.target.value)}
                                    sx={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    <MenuItem value="Samiec" sx={{fontFamily: "'Poppins', sans-serif"}}>Samiec</MenuItem>
                                    <MenuItem value="Samica" sx={{fontFamily: "'Poppins', sans-serif"}}>Samica</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Nr obrączki"
                                value={pigeonForm.number}
                                onChange={(e) => handlePigeonFormChange('number', e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        fontFamily: "'Poppins', sans-serif",
                                    },
                                    '& .MuiInputLabel-root': {
                                        fontFamily: "'Poppins', sans-serif",
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel sx={{fontFamily: "'Poppins', sans-serif"}}>Status</InputLabel>
                                <Select
                                    value={pigeonForm.status}
                                    label="Status"
                                    onChange={(e) => handlePigeonFormChange('status', e.target.value)}
                                    sx={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    <MenuItem value="Rozpłodowy" sx={{fontFamily: "'Poppins', sans-serif"}}>Rozpłodowy</MenuItem>
                                    <MenuItem value="Lotowy" sx={{fontFamily: "'Poppins', sans-serif"}}>Lotowy</MenuItem>
                                    <MenuItem value="Nieaktywny" sx={{fontFamily: "'Poppins', sans-serif"}}>Nieaktywny</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: '20px'}}>
                <Button 
                    onClick={handleCloseAddPigeon}
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'none',
                        color: '#707070'
                    }}
                >
                    Anuluj
                </Button>
                <Button 
                    onClick={handleSavePigeon}
                    variant="contained"
                    disabled={!pigeonForm.name || !pigeonForm.gender || !pigeonForm.number || !pigeonForm.status}
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'none',
                        backgroundColor: '#57C09A',
                        '&:hover': {
                            backgroundColor: '#4fcda2',
                        }
                    }}
                >
                    {editingPigeon ? 'Zapisz zmiany' : 'Dodaj'}
                </Button>
            </DialogActions>
        </Dialog>

        {/* Dialog do filtrowania */}
        <Dialog open={filterOpen} onClose={handleFilterClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: '28px', color: '#478E95'}}>
                Filtruj gołębie
            </DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 3, marginTop: 2}}>
                    <FormControl fullWidth>
                        <InputLabel sx={{fontFamily: "'Poppins', sans-serif"}}>Płeć</InputLabel>
                        <Select
                            value={filters.gender}
                            label="Płeć"
                            onChange={(e) => handleFilterChange('gender', e.target.value)}
                            sx={{
                                fontFamily: "'Poppins', sans-serif",
                            }}
                        >
                            <MenuItem value="" sx={{fontFamily: "'Poppins', sans-serif"}}>Wszystkie</MenuItem>
                            <MenuItem value="Samiec" sx={{fontFamily: "'Poppins', sans-serif"}}>Samiec</MenuItem>
                            <MenuItem value="Samica" sx={{fontFamily: "'Poppins', sans-serif"}}>Samica</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <InputLabel sx={{fontFamily: "'Poppins', sans-serif"}}>Status</InputLabel>
                        <Select
                            value={filters.status}
                            label="Status"
                            onChange={(e) => handleFilterChange('status', e.target.value)}
                            sx={{
                                fontFamily: "'Poppins', sans-serif",
                            }}
                        >
                            <MenuItem value="" sx={{fontFamily: "'Poppins', sans-serif"}}>Wszystkie</MenuItem>
                            <MenuItem value="Rozpłodowy" sx={{fontFamily: "'Poppins', sans-serif"}}>Rozpłodowy</MenuItem>
                            <MenuItem value="Lotowy" sx={{fontFamily: "'Poppins', sans-serif"}}>Lotowy</MenuItem>
                            <MenuItem value="Nieaktywny" sx={{fontFamily: "'Poppins', sans-serif"}}>Nieaktywny</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: '20px'}}>
                <Button 
                    onClick={handleClearFilters}
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'none',
                        color: '#707070'
                    }}
                >
                    Wyczyść filtry
                </Button>
                <Button 
                    onClick={handleApplyFilters}
                    variant="contained"
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'none',
                        backgroundColor: '#57C09A',
                        '&:hover': {
                            backgroundColor: '#4fcda2',
                        }
                    }}
                >
                    Zastosuj
                </Button>
            </DialogActions>
        </Dialog>

        {/* Dialog do sortowania */}
        <Dialog open={sortOpen} onClose={handleSortClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: '28px', color: '#478E95'}}>
                Sortuj gołębie
            </DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, marginTop: 2}}>
                    <Button
                        variant={sortBy === 'name-asc' ? 'contained' : 'outlined'}
                        onClick={() => handleSortChange('name-asc')}
                        sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textTransform: 'none',
                            backgroundColor: sortBy === 'name-asc' ? '#57C09A' : 'transparent',
                            borderColor: '#57C09A',
                            color: sortBy === 'name-asc' ? 'white' : '#57C09A',
                            '&:hover': {
                                backgroundColor: sortBy === 'name-asc' ? '#4fcda2' : 'rgba(87, 192, 154, 0.1)',
                                borderColor: '#4fcda2',
                            }
                        }}
                    >
                        Alfabetycznie A-Z
                    </Button>
                    <Button
                        variant={sortBy === 'name-desc' ? 'contained' : 'outlined'}
                        onClick={() => handleSortChange('name-desc')}
                        sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textTransform: 'none',
                            backgroundColor: sortBy === 'name-desc' ? '#57C09A' : 'transparent',
                            borderColor: '#57C09A',
                            color: sortBy === 'name-desc' ? 'white' : '#57C09A',
                            '&:hover': {
                                backgroundColor: sortBy === 'name-desc' ? '#4fcda2' : 'rgba(87, 192, 154, 0.1)',
                                borderColor: '#4fcda2',
                            }
                        }}
                    >
                        Alfabetycznie Z-A
                    </Button>
                    <Button
                        variant={sortBy === 'date-asc' ? 'contained' : 'outlined'}
                        onClick={() => handleSortChange('date-asc')}
                        sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textTransform: 'none',
                            backgroundColor: sortBy === 'date-asc' ? '#57C09A' : 'transparent',
                            borderColor: '#57C09A',
                            color: sortBy === 'date-asc' ? 'white' : '#57C09A',
                            '&:hover': {
                                backgroundColor: sortBy === 'date-asc' ? '#4fcda2' : 'rgba(87, 192, 154, 0.1)',
                                borderColor: '#4fcda2',
                            }
                        }}
                    >
                        Data dodania (najstarsze)
                    </Button>
                    <Button
                        variant={sortBy === 'date-desc' ? 'contained' : 'outlined'}
                        onClick={() => handleSortChange('date-desc')}
                        sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textTransform: 'none',
                            backgroundColor: sortBy === 'date-desc' ? '#57C09A' : 'transparent',
                            borderColor: '#57C09A',
                            color: sortBy === 'date-desc' ? 'white' : '#57C09A',
                            '&:hover': {
                                backgroundColor: sortBy === 'date-desc' ? '#4fcda2' : 'rgba(87, 192, 154, 0.1)',
                                borderColor: '#4fcda2',
                            }
                        }}
                    >
                        Data dodania (najnowsze)
                    </Button>
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: '20px'}}>
                <Button 
                    onClick={handleClearSort}
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'none',
                        color: '#707070'
                    }}
                >
                    Wyczyść sortowanie
                </Button>
                <Button 
                    onClick={handleSortClose}
                    variant="contained"
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'none',
                        backgroundColor: '#57C09A',
                        '&:hover': {
                            backgroundColor: '#4fcda2',
                        }
                    }}
                >
                    Zamknij
                </Button>
            </DialogActions>
        </Dialog>
        </div>
    );
} 

export default PigeonsNew;